import React from "react";

const ToolTip = ({ open, x = 0, y = 0, date = "Apr 10", views }) => {
  return (
    <div
      x={x}
      y={y}
      open={open}
      style={{
        backgroundColor: "#1b57cc",
        borderRadius: "4px",
        color: "white",
        display: open ? "block" : "none",
        height: "50px",
        left: `${x}px`,
        lineHeight: 1,
        padding: "8px",
        position: "absolute",
        top: `${y}px`,
        width:
          "100px" /* has increased slightly above spec to fit numbers up to 5 placed */,
        opacity: "0.85"
      }}
    >
      <h4
        style={{
          fontSize: "12px",
          fontWeight: "normal",
          marginBottom: "4px"
        }}
      >
        {date}
      </h4>
      <h5 style={{ fontSize: "15px", fontWeight: 300 }}>
        {views} <span styles={{ fontSize: "12px" }}> views</span>
      </h5>
    </div>
  );
};

// const HoverBox = styled.div`
//   background-color: #1b57cc;
//   border-radius: 4px;
//   color: white;
//   display: ${p => (p.open ? "block" : "none")};
//   height: 50px;
//   left: ${p => p.x}px;
//   line-height: 1;
//   padding: 8px;
//   position: absolute;
//   top: ${p => p.y}px;
//   width: 100px; /* has increased slightly above spec to fit numbers up to 5 placed */
//   opacity: 0.8;
//   h4 {
//   }
//   h5 {
//     span {
//     }
//   }
// `;

export default ToolTip;



// WEBPACK FOOTER //
// ./src/tooltip.jsx